import {Button, Heading, Hero, Link, Text} from '~/modules';

import {BaseLayout} from '~/modules/Layout/components/BaseLayout';
import {Container} from '~/modules/Layout/components/Container';
import {HeadersFunction} from '@shopify/remix-oxygen';
import {SeoHandleFunction} from '@shopify/hydrogen';
import {loader} from '~/modules/Product/loaders/allProductsLoader';
import {useExpert} from '~/modules/Common/hooks/useExpert';
import {useExpertTheme} from '~/modules/Expert/hooks/useExpertTheme';

export const headers: HeadersFunction = () => ({
  'Cache-Control': 'max-age=300, s-maxage=900',
});

const seo: SeoHandleFunction<typeof loader> = ({data, params}) => {
  const expertName = data.expertName || params.expertName;
  const title = `${expertName} invites you to join our curated store`;
  const description = `Join Wayward`;
  const domain = `https://www.wayward.com/${expertName}`;
  const image = data?.hero || '';
  return {
    title,
    description,
    'og:title': title,
    'og:description': description,
    'og:type': 'article',
    'og:url': domain,
    'og:image': image,
    'twitter:image': image,
    'twitter:card': 'summary_large_image',
    'twitter:domain': domain,
    'twitter:url': domain,
    'twitter:title': title,
    'twitter:description': description,
  };
};

export const handle = {
  seo,
};

export {loader};

export default () => {
  const {expertName} = useExpert();
  const theme = useExpertTheme();
  return (
    <BaseLayout>
      <Hero
        title={`${expertName} invites you to join our curated store!`}
        image={{src: theme.store.hero || '', alt: ''}}
        mobileImage={{src: theme.store.heroMobile || '', alt: ''}}
        containerClassName="!justify-end pb-2 max-w-[600px] mx-auto"
      />

      <Container
        maxWidth="form"
        className="flex flex-col items-center gap-6 py-6 text-center"
      >
        <Heading size="headlineSm">
          Sign up and start selling your products through creator curated stores
          today!
        </Heading>
        <Button href="/brand/signup?screen_hint=signup" className="px-11">
          Sign Up
        </Button>
        <div className="bg-codGray100 p-8 flex flex-col items-center justify-center gap-4">
          <Text size="sm">{`${expertName} is using their Wayward store to drive more sales for products like yours. Wayward allows creators to sell your products in their own personalized storefronts, alongside their content, providing customers with an exceptional shopping experience that converts better than affiliate links.`}</Text>
          <Text size="sm">It only takes a few minutes to sign up!</Text>
          <Button href="/brand/signup?screen_hint=signup" className="px-11">
            Sign Up
          </Button>
          <Button
            href="https://calendly.com/alidecker/30min"
            target="_blank"
            color="secondary"
          >
            Schedule a demo
          </Button>
          <Link to="/" noPrefix={true} className="underline text-sm">
            Learn More
          </Link>
        </div>
      </Container>
    </BaseLayout>
  );
};
